// Material UI imports
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const DESKTOP_ONLY_BREAKPOINT = 'md';

const useIsNarrowScreen = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(
    // `down()`, not `up()`: jsdom answers `matches: false` to everything, so `up()` would make every
    // storyshot record the narrow branch.
    theme.breakpoints.down(DESKTOP_ONLY_BREAKPOINT)
  );
};

export default useIsNarrowScreen;
